import { MARQUEE_ITEMS } from '../data/content';

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item, i) => (
      <span key={i} className="flex items-center shrink-0">
        <span className="font-serif italic text-2xl sm:text-3xl text-[#F2E5CF]/70 px-8 whitespace-nowrap">{item}</span>
        <svg viewBox="0 0 12 12" className="w-2.5 h-2.5 fill-gold shrink-0" aria-hidden="true">
          <path d="M6 0 L7.5 4.5 L12 6 L7.5 7.5 L6 12 L4.5 7.5 L0 6 L4.5 4.5 Z" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="border-y border-[#47201F] bg-[#140708] py-6 overflow-hidden select-none" aria-hidden="true">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
